// services/salesService.js - Versão com URL corrigida
class SalesService {
  constructor() {
    // ✅ CORRIGIR URL PARA USAR PORTA 8000 (Django backend)
    this.baseURL = '/dashboard/api/sales';
  }

  // ✅ Método robusto para fazer requisições (mantido)
  async makeRequest(url, options = {}) {
    const token = localStorage.getItem('access_token');
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      }
    };

    // Adicionar token apenas se existir
    if (token) {
      defaultOptions.headers['Authorization'] = `Bearer ${token}`;
    }

    const requestOptions = { ...defaultOptions, ...options };
    const fullUrl = `${this.baseURL}${url}`;

    try {
      console.log(`🛒 Sales Request: ${requestOptions.method || 'GET'} ${fullUrl}`);
      console.log(`🔑 Headers:`, requestOptions.headers);
      
      if (requestOptions.body) {
        console.log(`📦 Body:`, requestOptions.body);
      }
      
      const response = await fetch(fullUrl, requestOptions);
      
      console.log(`📡 Sales Response status: ${response.status} ${response.statusText}`);
      
      // Verificar se a resposta é JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('❌ Sales Response não é JSON:', contentType);
        const textResponse = await response.text();
        console.error('Response body:', textResponse.substring(0, 200));
        throw new Error(`Servidor retornou ${response.status}: ${response.statusText}. Verifique se a URL de vendas está correta.`);
      }

      if (!response.ok) {
        // Tratamento específico para erro 401
        if (response.status === 401) {
          console.log('🔒 Token expirado ou inválido para vendas');
          localStorage.removeItem('access_token');
          alert('Sessão expirada. Redirecionando para login...');
          window.location.href = '/login';
          throw new Error('Sessão expirada');
        }

        // Tratamento específico para erro 403 - empresa não associada
        if (response.status === 403) {
          const errorData = await response.json().catch(() => ({}));
          console.error('🚫 Erro 403 - Usuário sem empresa:', errorData);
          throw new Error(errorData.error || 'Usuário não possui empresa associada. Verifique se seu usuário está vinculado a uma empresa.');
        }

        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || errorData.error || `HTTP Error: ${response.status}`);
      }

      const jsonResponse = await response.json();
      console.log('✅ Sales Response data:', jsonResponse);
      return jsonResponse;

    } catch (error) {
      console.error('❌ Sales Request failed:', error);
      
      // Melhor mensagem de erro para o usuário
      if (error.message.includes('Failed to fetch')) {
        throw new Error('Erro de conexão. Verifique se o servidor Django está rodando na porta 8000.');
      }
      
      throw error;
    }
  }

  // ✅ Buscar resumo dos pedidos com parâmetros corretos
  async getSummary(filters = {}) {
    const params = new URLSearchParams();
    
    // Usar parâmetros corretos para vendas baseado no backend
    if (filters.startDate) params.append('DataEmissaoInicial', filters.startDate);
    if (filters.endDate) params.append('DataEmissaoFinal', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);

    const queryString = params.toString();
    const url = queryString ? `/summary/?${queryString}` : '/summary/';
    
    return await this.makeRequest(url);
  }

  // ✅ Buscar pedidos com paginação e parâmetros corretos
  async getOrders(filters = {}, page = 1, pageSize = 20) {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString()
    });

    // Usar parâmetros corretos para vendas baseado no backend
    if (filters.startDate) params.append('DataEmissaoInicial', filters.startDate);
    if (filters.endDate) params.append('DataEmissaoFinal', filters.endDate);
    if (filters.status) params.append('status', filters.status);
    if (filters.tipo) params.append('tipo', filters.tipo);
    if (filters.status_lancamento) params.append('status_lancamento', filters.status_lancamento);
    if (filters.search) params.append('search', filters.search);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortDirection) params.append('sortDirection', filters.sortDirection);

    return await this.makeRequest(`/orders/?${params.toString()}`);
  }

  // ✅ Sincronizar dados com a API M8
  async syncData(syncParams) {
    if (!syncParams.start_date || !syncParams.end_date) {
      throw new Error('Parâmetros start_date e end_date são obrigatórios');
    }

    return await this.makeRequest('/sync/', {
      method: 'POST',
      body: JSON.stringify(syncParams)
    });
  }

  // ✅ Validar parâmetros de sincronização (mantido)
  validateSyncDates(startDate, endDate) {
    if (!startDate || !endDate) {
      return { valid: false, message: 'Data inicial e final são obrigatórias para sincronização' };
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (start > end) {
      return { valid: false, message: 'Data inicial deve ser anterior à data final' };
    }

    const diffDays = (end - start) / (1000 * 60 * 60 * 24);
    if (diffDays > 365) {
      return { valid: false, message: 'Período máximo permitido: 365 dias' };
    }

    return { valid: true };
  }

  // ✅ Método de debug para testar se as URLs de vendas estão funcionando
  async debugUrls() {
    console.log('🔍 Testando URLs do salesService...');
    
    const token = localStorage.getItem('access_token');
    const headers = token ? {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    } : {};
    
    const urls = [
      '/summary/',
      '/orders/',
      '/sync/' // Nota: este vai dar 405 porque é POST only
    ];

    for (const url of urls) {
      try {
        const response = await fetch(`${this.baseURL}${url}`, { headers });
        console.log(`🛒 ${url}: ${response.status} ${response.statusText}`);
        if (!response.ok) {
          const text = await response.text();
          console.log(`📄 Response: ${text.substring(0, 200)}`);
        }
      } catch (error) {
        console.error(`❌ ${url}: ${error.message}`);
      }
    }
  }

  // ✅ Método helper para debug de token (mantido)
  debugToken() {
    const token = localStorage.getItem('access_token');
    if (token) {
      console.log(`🔑 Token encontrado: ${token.substring(0, 50)}...`);
      
      // Decodificar JWT básico para debug (não para produção)
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log(`👤 Token payload:`, payload);
        
        const exp = payload.exp * 1000;
        const now = Date.now();
        const timeLeft = exp - now;
        
        if (timeLeft > 0) {
          console.log(`⏱️ Token expira em: ${Math.round(timeLeft / 1000 / 60)} minutos`);
        } else {
          console.log(`⚠️ Token EXPIRADO há: ${Math.round(Math.abs(timeLeft) / 1000 / 60)} minutos`);
        }
      } catch (e) {
        console.log(`❌ Erro ao decodificar token: ${e.message}`);
      }
    } else {
      console.log(`❌ Nenhum token encontrado no localStorage`);
    }
  }

  // ✅ Método para debug do problema de empresa
  async debugUserCompany() {
    console.log('🏢 Verificando informações do usuário e empresa...');
    
    try {
      // Tentar obter informações do usuário
      const response = await fetch('/api/user/me/', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const userData = await response.json();
        console.log('👤 Dados do usuário:', userData);
        
        if (userData.company) {
          console.log('✅ Usuário tem empresa associada:', userData.company);
        } else {
          console.log('❌ Usuário SEM empresa associada');
          console.log('🔧 Solução: Associar usuário a uma empresa no Django Admin');
        }
      } else {
        console.log('❌ Erro ao obter dados do usuário:', response.status);
      }
    } catch (error) {
      console.log('❌ Erro na verificação:', error.message);
    }
  }
}

// Instância singleton
export const salesService = new SalesService();

// Debug helper - remover em produção
window.salesService = salesService;
